import {
  OnInit,
  Component,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';

import { CONFIG } from '../config';
import { ToolbarComponent } from './components/toolbar/toolbar.component';

@Component({
  selector: 'app-root',
  template: `<div class="sticky top-0 z-50"><app-toolbar></app-toolbar></div>
    <router-outlet></router-outlet>`,
  standalone: true,
  imports: [ToolbarComponent, RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private titleService = inject(Title);
  private swUpdate = inject(SwUpdate);
  private snackBar = inject(MatSnackBar);

  public ngOnInit(): void {
    this.titleService.setTitle(CONFIG.app.name);
    this.checkForUpdates();
  }

  private checkForUpdates(): void {
    if (this.swUpdate.isEnabled) {
      // Vérifier les mises à jour toutes les 5 minutes
      setInterval(
        () => {
          void this.swUpdate.checkForUpdate();
        },
        5 * 60 * 1000,
      );

      // Écouter les nouvelles versions disponibles
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          const snackBarRef = this.snackBar.open(
            'Nouvelle version disponible',
            'Recharger',
            { duration: 30_000 },
          );

          snackBarRef.onAction().subscribe(() => {
            window.location.reload();
          });
        }
      });
    }
  }
}
